export const BASE_URL = process.env.REACT_APP_API_URL || 'https://internal.bijacreative.com'
export const INSIGHT_API_URL = process.env.REACT_APP_API_URL || 'https://internal.bijacreative.com'
  